import { Breadcrumbs, Typography, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { usePrincipalComprasViewModel } from "../../viewModels/principal_compras_view_model";
import { PrincipaisDocGrid } from "../../../../../common/components/principaisDocGrid";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import StatCard from "../../../../../common/components/statCard";
import StatCardString from "../../../../../common/components/statCardString";
import { CalendarMonth, Cancel, Check, DoNotDisturb, Warning } from "@mui/icons-material";

export const PrincipalCompras = () => {
  const viewModel = usePrincipalComprasViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Compras
          </Link>
          <Typography className="text-primary-green">
            Principal Compras
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Principal Compras</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                {
                  viewModel.dashboardComprasInformation !== null && (
                    <div className="w-full flex flex-col gap-4 mb-8">
                      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                        <StatCard
                          title='Requisições Pendentes'
                          value={viewModel.dashboardComprasInformation.requisicoesPendentes}
                          icon={CalendarMonth}
                          colorClass={{
                            bg: 'bg-zinc-500',
                            text: 'text-white',
                            bgHover: 'bg-zinc-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('requisicoesPendentes')}
                        />

                        <StatCard
                          title='Requisições Em Atraso'
                          value={viewModel.dashboardComprasInformation.requisicoesEmAtraso}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('requisicoesEmAtraso')}
                        />

                        <StatCard
                          title='Requisições Aprovadas'
                          value={viewModel.dashboardComprasInformation.requisicoesAprovadas}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('requisicoesAprovadas')}
                        />

                        <StatCard
                          title='Requisições Reprovadas'
                          value={viewModel.dashboardComprasInformation.requisicoesReprovadas}
                          icon={DoNotDisturb}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('requisicoesReprovadas')}
                        />

                        <StatCard
                          title='Requsições Finalizadas'
                          value={viewModel.dashboardComprasInformation.requisicoesFinalizadas}
                          icon={DoNotDisturb}
                          colorClass={{
                            bg: 'bg-indigo-500',
                            text: 'text-white',
                            bgHover: 'bg-indigo-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('requisicoesFinalizadas')}
                        />

                        <StatCard
                          title='Requisições para Revisar'
                          value={viewModel.dashboardComprasInformation.requisicoesRevisar}
                          icon={CalendarMonth}
                          colorClass={{
                            bg: 'bg-zinc-500',
                            text: 'text-white',
                            bgHover: 'bg-zinc-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('requisicoesRevisar')}
                        />

                        <StatCard
                          title='Ordem de Compra Pendentes'
                          value={viewModel.dashboardComprasInformation.ordemCompraPendentes}
                          icon={CalendarMonth}
                          colorClass={{
                            bg: 'bg-zinc-500',
                            text: 'text-white',
                            bgHover: 'bg-zinc-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('ordemCompraPendentes')}
                        />

                        <StatCardString
                          title='Ordem de Compra Entregues'
                          value={viewModel.dashboardComprasInformation.ordemCompraEntregues}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('ordemCompraEntregues')}
                        />

                        <StatCard
                          title='Ordem de Compra Canceladas'
                          value={viewModel.dashboardComprasInformation.ordemCompraCanceladas}
                          icon={Cancel}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('ordemCompraCanceladas')}
                        />

                        <StatCard
                          title='Documentos Vencidos'
                          value={viewModel.dashboardComprasInformation.documentosVencidos}
                          icon={Cancel}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('documentosVencidos')}
                        />

                        <StatCard
                          title='Coletas em Elaboração'
                          value={viewModel.dashboardComprasInformation.coletasEmElaboracao}
                          icon={CalendarMonth}
                          colorClass={{
                            bg: 'bg-zinc-500',
                            text: 'text-white',
                            bgHover: 'bg-zinc-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('coletasEmElaboracao')}
                        />

                        <StatCard
                          title='Coletas Finalizadas para Aprovação'
                          value={viewModel.dashboardComprasInformation.coletasFinalizadas}
                          icon={Cancel}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('coletasFinalizadas')}
                        />

                        <StatCard
                          title='Coletas Aprovadas'
                          value={viewModel.dashboardComprasInformation.coletasAprovadas}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('coletasAprovadas')}
                        />

                        <StatCard
                          title='Coletas Reprovadas'
                          value={viewModel.dashboardComprasInformation.coletasReprovadas}
                          icon={Cancel}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('coletasReprovadas')}
                        />

                        <StatCard
                          title='Coletas Gerou Ordem de Compra'
                          value={viewModel.dashboardComprasInformation.coletasGerouOrdemCompra}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-indigo-500',
                            text: 'text-white',
                            bgHover: 'bg-indigo-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('coletasGerouOrdemCompra')}
                        />

                        {viewModel.dashboardComprasInformation.mediaGeralAprovacaoFornecedores !== null && (
                          <StatCardString
                            title='Média Geral Avaliação Fornecedores'
                            value={
                              new Intl.NumberFormat('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }).format(viewModel.dashboardComprasInformation.mediaGeralAprovacaoFornecedores)
                            }
                            icon={Check}
                            colorClass={{
                              bg: 'bg-teal-500',
                              text: 'text-white',
                              bgHover: 'bg-teal-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('mediaGeralAprovacaoFornecedores')}
                          />
                        )}

                        {viewModel.dashboardComprasInformation.notaCorte !== null && (
                          <StatCard
                            title='Entrega Ordem Compra em Atraso'
                            value={viewModel.dashboardComprasInformation.notaCorte}
                            icon={Warning}
                            colorClass={{
                              bg: 'bg-red-500',
                              text: 'text-white',
                              bgHover: 'bg-red-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('entregaOrdemCompraAtraso')}
                          />
                        )}
                      </div>

                      <PrincipaisDocGrid
                        loading={viewModel.loading}
                        rows={viewModel.docLista}
                        totalItems={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onPageChange={(p) => viewModel.handlePageChange(p)}
                        onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
                        onActionExportar={(IdArquivoModulo, NomeArquivo) =>
                          viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)
                        }
                      />
                    </div>
                  )
                }
              </>
            )
        }
      </div>
    </>
  );
}